var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle-xmark-solid 3",
    clipPath: "url(#clip0_1436_8480)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6 12.5C7.5913 12.5 9.11742 11.8679 10.2426 10.7426C11.3679 9.61742 12 8.0913 12 6.5C12 4.9087 11.3679 3.38258 10.2426 2.25736C9.11742 1.13214 7.5913 0.5 6 0.5C4.4087 0.5 2.88258 1.13214 1.75736 2.25736C0.632141 3.38258 0 4.9087 0 6.5C0 8.0913 0.632141 9.61742 1.75736 10.7426C2.88258 11.8679 4.4087 12.5 6 12.5ZM4.10156 4.60156C4.32188 4.38125 4.67812 4.38125 4.89609 4.60156L5.99766 5.70312L7.09922 4.60156C7.31953 4.38125 7.67578 4.38125 7.89375 4.60156C8.11172 4.82188 8.11406 5.17812 7.89375 5.39609L6.79219 6.49766L7.89375 7.59922C8.11406 7.81953 8.11406 8.17578 7.89375 8.39375C7.67344 8.61172 7.31719 8.61406 7.09922 8.39375L5.99766 7.29219L4.89609 8.39375C4.67578 8.61406 4.31953 8.61406 4.10156 8.39375C3.88359 8.17344 3.88125 7.81719 4.10156 7.59922L5.20312 6.49766L4.10156 5.39609C3.88125 5.17578 3.88125 4.81953 4.10156 4.60156Z",
    fill: "#D4D8DB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1436_8480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleXmark);
export default __webpack_public_path__ + "static/media/circle-xmark.ead55ee810fe7f92c827b04dde4aefca.svg";
export { ForwardRef as ReactComponent };